import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircle } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { Container } from '../container';
export const SuccessWidget = ({ text, returnTo }) => {
    return (_jsx(Container, { maxWidth: "xs", children: _jsxs(Stack, { spacing: 2, paddingTop: 8, alignItems: "center", children: [_jsx(CheckCircle, { color: "success", sx: { fontSize: 92 } }), _jsxs(Stack, { spacing: 8, children: [_jsx(Typography, { align: "center", variant: "h6", children: text }), _jsx(Button, { variant: "contained", component: Link, to: returnTo, children: "Return to dashboard" })] })] }) }));
};
